import { render, staticRenderFns } from "./pointDetails.vue?vue&type=template&id=cdb2907e&scoped=true&"
import script from "./pointDetails.vue?vue&type=script&lang=js&"
export * from "./pointDetails.vue?vue&type=script&lang=js&"
import style0 from "./pointDetails.vue?vue&type=style&index=0&id=cdb2907e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb2907e",
  null
  
)

export default component.exports